import type { TeamInfoApiData } from '../types';
import { PREMATCH_JERSEYS_BASE_URL } from './urls';

export const TEAM_INFO_MOCK_DATA: TeamInfoApiData = {
  home: {
    name: 'Manchester City',
    jersey: `${PREMATCH_JERSEYS_BASE_URL}/jersey109_blue_png.png`,
    is_national_team: false,
  },
  away: {
    name: 'Nottingham Forest',
    jersey: `${PREMATCH_JERSEYS_BASE_URL}/jersey109_red_png.png`,
    is_national_team: false,
  },
  lineup_available: true,
};
